<template>
	<v-dialog v-model="dialogValue" max-width="500px">
		<v-card class="pa-7">
			<v-card-title class="pl-0 pr-0 pt-0 ">
				<v-icon left>person</v-icon>Alterar senha
				<v-spacer></v-spacer>
				<v-btn icon @click="dialogClose">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>
			<v-form>
			<v-text-field
				prepend-icon="lock"
				label="Nova senha"
				v-model="senha.nova"
				@click:append="show = !show"
				:type="show ? 'text' : 'password'"
				class="mb-3"
				hide-details
			>
				<template v-slot:append>
					<v-icon color="primary" @click="show = !show">
						{{ show ? 'mdi-eye' : 'mdi-eye-off' }}
					</v-icon>
				</template>
			</v-text-field>
			<v-text-field
				prepend-icon="lock"
				label="Confirmação de nova senha"
				v-model.lazy="senha.confirmada"
				@click:append="show2 = !show2"
				:type="show2 ? 'text' : 'password'"
				class="mb-3"
				hide-details
			>
				<template v-slot:append>
					<v-icon color="primary" @click="show2 = !show2">
						{{ show2 ? 'mdi-eye' : 'mdi-eye-off' }}
					</v-icon>
				</template>
			</v-text-field>
			</v-form>
			<v-btn class="white--text mt-3" @click="salvar()" color="primary" large elevation="9" width="100%">
				Salvar
			</v-btn>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'

export default {
	props: {
		abrirDialog: Boolean,
		id: String
	},
	data() {
		return {
			show: false,
			show2: false,
			senha: {},
			loading: false,
		}
	},
	computed: {
		...mapGetters(['userAdmin', 'userMaster']),
		...mapState('usuarios', ['usuario', 'dialog']),
		dialogValue: {
			get() {
				return this.abrirDialog
			},
			set() {
				this.dialogClose()
			},
		},
	},
	methods: {
		...mapMutations('usuarios', ['setDialog']),
		...mapActions('usuarios', ['hideDialog']),
		dialogClose() {
			this.senha = {}
			this.show = this.show2 = false
			this.$emit('dialogClose')
		},
		async salvar() {
			try {
				this.loading = true
				const response = await this.axios.put(`/usuario/${this.id}/alterarsenha`, {
					senha: this.senha,
				})

				if (response.status == 204) {
					this.$store.dispatch('showSuccess', 'Senha alterada com sucesso!')
					this.dialogClose()
				}
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
	},
}
</script>
